function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/esnext.string.at.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRoute } from '@nuxtjs/composition-api';
import { SIcon } from '@strana-artw/ui-kit';
import { computed, defineComponent, ref, set, toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
import { ROUTE_PATHS } from '@/shared/constants';
import RemoteSVG from '@/shared/ui/RemoteSVG.vue';
import { useMenuStore } from '@/store/menu';
import MenuMobileHead from './MenuMobileHead.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenu',
  emits: ["menu-item-click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'AppMenu'
    });
    var links = ref([{
      link: 'https://strana.com/about/',
      title: 'О компании'
    }, {
      link: 'https://strana.com/contacts/',
      title: 'Телефоны офисов'
    }, {
      link: 'https://strana.com/documents/',
      title: 'Проектные документы ЖК'
    }, {
      link: 'https://strana.com/journal/progress/ ',
      title: 'Фото хода строительства ЖК'
    }, {
      link: 'https://strana.com/journal/stream/ ',
      title: 'Онлайн трансляция ЖК'
    }]);
    var screen = useScreenPlugin();
    var _toRefs = toRefs(useMenuStore()),
      headerMenu = _toRefs.headerMenu;
    var route = useRoute();
    function clearQuery(link) {
      var index = link.indexOf('?');
      return index > -1 ? link.slice(0, index) : link;
    }
    var activeMenuItems = computed(function () {
      var result = {};
      var _iterator = _createForOfIteratorHelper(headerMenu.value),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          set(result, item.link, false);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(headerMenu.value),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _route$value$matched$, _route$value$matched$2;
          var _item = _step2.value;
          if ((_route$value$matched$ = route.value.matched.at(-1)) !== null && _route$value$matched$ !== void 0 && _route$value$matched$.regex.test(clearQuery(_item.link))) {
            set(result, _item.link, true);
            break;
          }
          if ((_route$value$matched$2 = route.value.matched[0]) !== null && _route$value$matched$2 !== void 0 && _route$value$matched$2.regex.test(_item.link)) {
            set(result, _item.link, true);
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return result;
    });
    return {
      __sfc: true,
      emit: emit,
      links: links,
      screen: screen,
      headerMenu: headerMenu,
      route: route,
      clearQuery: clearQuery,
      activeMenuItems: activeMenuItems,
      SIcon: SIcon,
      ROUTE_PATHS: ROUTE_PATHS,
      RemoteSVG: RemoteSVG,
      MenuMobileHead: MenuMobileHead
    };
  }
});